// src/components/SearchBar.tsx
import React from "react";
import { styled } from "@mui/material/styles";
import { DebounceInput } from "react-debounce-input";
// import SearchIcon from "@mui/icons-material/Search";
import { ReactComponent as SearchIcon} from '../assets/svgs/searchIcon.svg'
import { Box } from "@mui/material";

interface SearchProps {
  searchText: string;
  setSearchText: (text: string) => void;
}

const Search: React.FC<SearchProps> = ({ searchText, setSearchText }) => {
  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    setSearchText(value);
  };

  return (
    <SearchWrapper sx={{ width:{xs:'100%',md:'auto'}}}>
      <Input
        type="search"
        minLength={1}
        debounceTimeout={1000}
        value={searchText}
        onChange={handleSearchChange}
        placeholder="Search by name"
        sx={{ width:{xs:'100%!important',md:'350px !important'}}}
      />


      <Box style={{
          position: 'absolute',
          right: '8px',
          top: '55%',
          transform: 'translateY(-50%)',
          color: '#565656',
        }}
        >
          <SearchIcon/>
        </Box>
      {/* <SearchIcon
        style={{
          position: 'absolute',
          right: '10px',
          top: '50%',
          transform: 'translateY(-50%)',
          color: '#565656',
        }}
      /> */}
    </SearchWrapper>
  );
};

export default Search;

const Input = styled(DebounceInput)`
  &&& {
    border: 1px solid rgba(0, 0, 0, 0.23);
    padding: 10px;
    font-size: 14px;
    border-radius: 25px;
    width: 350px;
    height: 56px;
    background-color:transparent;
    
    &:focus {
      border: 1px solid #d3d3d3;
      outline: none;
      box-shadow: none;
    }
    
    &::-webkit-search-cancel-button {
      -webkit-appearance: none;
    }
    
    /* Placeholder styling */
    &::placeholder {
      font-size: 12px;  
      color: #3333;      
      opacity: 1;      
    }
  }
`;

const SearchWrapper = styled("div")`
  position: relative;
`;
